import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { PDxUserPermission } from 'src/app/core/PDxUserPermission.enum';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { UserAssignmentInformation } from '../models/user-assignment-information.model';
import { UserDetail } from '../models/user-detail.model';

@Component({
  selector: 'app-view-user-assignment',
  templateUrl: './view-user-assignment.component.html',
  styles: [
  ]
})
export class ViewUserAssignmentComponent implements OnInit {

  @Input() user: UserDetail;
  @Input() parentId: string;
  @ViewChild(NgForm) assignmentForm: NgForm;

  filterCount: number = 0;
  accountId: string = null;
  accounts: PDxListItem<string>[] = [];
  parents: PDxListItem<string>[] = [];
  assignment: UserAssignmentInformation = new UserAssignmentInformation();
  submitAttempt: boolean = false;
  stepNumber: number = 1;

  accountOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            this.validateCurrentAccount();
          }
        }, () => { });
      } else {
        this.validateCurrentAccount();
      }
      return false;
    },
    onChange: (ev: any) => {
      this.assignment.hierarchy = this.accounts.filter((x) => x.value == ev.value);
      this.parentId = null;
      this.parents = [];
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.assignment.hierarchy = [];
        this.accountId = null;
        this.parentId = null;
        this.parents = [];
      }
    }]
  };

  parentOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.parents = [];
      if (!this.accountId) {
        return false;
      }
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: this.accountId, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.parents = data;
            this.validateCurrentParent()
          }
        }, () => { });
      } else {
        this.validateCurrentParent()
      }
      return false;
    },
    onChange: (ev: any) => {
      this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/Hierarchy', { entityId: this.parentId }, false).then((data) => {
        this.assignment.hierarchy = data;
      }, () => { });
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.assignment.hierarchy = this.accounts.filter((x) => x.value == this.accountId);
        this.parentId = null;
      }
    }]
  };

  permissionOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    selectMultiple: true,
  };

  permissions: PDxListItem<PDxUserPermission>[] = PDxLists.PDxUserPermissions();

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.parentId) {
      this.getAssignment();
      this.stepNumber = 3;
    } else {
      this.assignment.userId = this.user.userId;
    }
  }

  getAssignment(): void {
    this.ajax.MakeCall<UserAssignmentInformation>('/User/GetAssignment', { userId: this.user.userId, entityId: this.parentId || this.accountId }).then((data) => {
      this.assignment = data
    }, () => { });
  }

  validateCurrentAccount(): void {
    if (this.assignment.hierarchy.length > 0) {
      if (this.accounts.filter((x) => x.value == this.assignment.hierarchy[0].value).length == 0) {
        this.accounts.splice(0, 0, this.assignment.hierarchy[0]);
      }
    }
  }

  validateCurrentParent(): void {
    if (this.assignment.hierarchy.length > 1) {
      if (this.parents.filter((x) => x.value == this.assignment.hierarchy[this.assignment.hierarchy.length - 1].value).length == 0) {
        this.parents.splice(0, 0, this.assignment.hierarchy[this.assignment.hierarchy.length - 1]);
      }
    }
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  nextStep(): void {
    if (!this.assignmentForm.valid) {
      this.submitAttempt = true;
      return;
    }
    this.submitAttempt = false;
    this.getAssignment();
    this.stepNumber++;
  }

  previousStep(): void {
    this.submitAttempt = false;
    this.stepNumber--;
  }

  saveAssignment(): void {
    if (!this.assignmentForm.valid) {
      this.submitAttempt = true;
      return;
    }
    this.ajax.MakeCall<boolean>('/User/SaveAssignment', this.assignment).then((data) => {
      this.modal.close();
    }, () => { });

  }
}
